var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantasialandBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 38,
    viewBox: "0 0 258 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.877 13.2287H237.432V27.108H250.877L255.648 22.7707V18.4334L250.877 13.2287Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1344 29.2766L26.2066 16.2648L27.074 13.2287L34.0137 29.2766H20.1344Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3865 29.2766L83.4587 16.2648L84.3261 13.2287L91.2657 29.2766H77.3865Z",
    fill: "#CF1463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3865 29.2766L83.4587 16.2648L84.3261 13.2287L91.2657 29.2766H77.3865Z",
    fill: "#CF1463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5177 21.4695H8.78298V17.566H19.5177V21.4695ZM19.5177 9.75886V13.6624H3.90355V29.2766H0V9.75886H19.5177Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9865 29.2766L26.7454 8.78298L36.5043 29.2766H32.1128L26.7454 18.0539L21.378 29.2766H16.9865Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5667 15.6142V37.0837H37.6631V9.75886H41.5667L53.2773 23.4213V0H57.1809V29.2766H53.2773L41.5667 15.6142Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0567 13.6624V37.0837H67.1532V13.6624H59.3461V9.75886H78.8638V13.6624H71.0567Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8624 29.2766L83.6213 8.78298L93.3801 29.2766H88.9887L83.6213 18.0539L78.2539 29.2766H73.8624Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.777 29.2766H94.356V25.373H117.777C118.326 25.373 118.784 25.1901 119.15 24.8241C119.536 24.4378 119.729 23.9702 119.729 23.4213C119.729 22.8723 119.536 22.4149 119.15 22.0489C118.784 21.6626 118.326 21.4695 117.777 21.4695H109.97C108.344 21.4695 106.961 20.9002 105.823 19.7617C104.684 18.6232 104.115 17.2407 104.115 15.6142C104.115 13.9877 104.684 12.6052 105.823 11.4667C106.961 10.3281 108.344 9.75886 109.97 9.75886H121.681V13.6624H109.97C109.421 13.6624 108.954 13.8556 108.567 14.2418C108.201 14.6078 108.018 15.0652 108.018 15.6142C108.018 16.1631 108.201 16.6307 108.567 17.017C108.954 17.383 109.421 17.566 109.97 17.566H117.777C119.404 17.566 120.786 18.1352 121.925 19.2738C123.063 20.4123 123.633 21.7948 123.633 23.4213C123.633 25.0478 123.063 26.4303 121.925 27.5688C120.786 28.7073 119.404 29.2766 117.777 29.2766Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.549 29.2766H125.645V9.75886H129.549V29.2766Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.525 29.2766L140.284 8.78298L150.043 29.2766H145.651L140.284 18.0539L134.916 29.2766H130.525Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.464 25.373H189.078V29.2766H169.56V9.75886H173.464V25.373Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.054 29.2766L199.813 8.78298L209.572 29.2766H205.18L199.813 18.0539L194.445 29.2766H190.054Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.634 15.6142V37.0837H210.73V9.75886H214.634L226.345 23.4213V0H230.248V29.2766H226.345L214.634 15.6142Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.241 29.2766H234.579V9.75886H248.241C250.945 9.75886 253.243 10.7144 255.133 12.6255C257.044 14.5163 258 16.8137 258 19.5177C258 22.2217 257.044 24.5293 255.133 26.4404C253.243 28.3312 250.945 29.2766 248.241 29.2766ZM238.482 25.373H248.241C249.868 25.373 251.25 24.8038 252.389 23.6652C253.527 22.5267 254.096 21.1442 254.096 19.5177C254.096 17.8913 253.527 16.5087 252.389 15.3702C251.25 14.2317 249.868 13.6624 248.241 13.6624H238.482V25.373Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasialandBlack);
export default __webpack_public_path__ + "static/media/fantasialand_black.a8208ec5645f934b9cddf97076f66332.svg";
export { ForwardRef as ReactComponent };